import * as hostBridge from "mcpApp/utils/hostBridge";

export function isFullsceenAllowed() {
    if (window.isMcpApp) {
        return true;
    }

    return document.fullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.documentElement.webkitRequestFullScreen;
}

export function isFullscreen() {
    if (window.isOfflinePlayer) {
        return !!window.isFullscreen;
    }

    if (window.isMcpApp) {
        return hostBridge.isFullscreen();
    }

    return (
        document.fullscreenElement != undefined ||
        document.webkitFullscreenElement != undefined ||
        document.mozFullscreenElement != undefined ||
        document.msFullscreenElement != undefined
    );
}

export function enterFullscreen() {
    if (window.isOfflinePlayer) {
        document.dispatchEvent(new CustomEvent("enter-fullscreen"));
        return;
    }

    if (window.isMcpApp) {
        hostBridge.enterFullscreen();
        return;
    }

    // Check if we're inside an iframe
    const isInIframe = window !== window.top;

    if (isInIframe) {
        // Try to make the iframe element fullscreen directly
        const iframe = window.frameElement;
        if (iframe) {
            requestFullscreen(iframe);
            return;
        }
    }

    requestFullscreen(document.body);
}

function requestFullscreen(element) {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    }
}

export function exitFullscreen() {
    if (window.isOfflinePlayer) {
        document.dispatchEvent(new CustomEvent("exit-fullscreen"));
        return;
    }

    if (window.isMcpApp) {
        hostBridge.exitFullscreen();
        return;
    }

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    }
}

export function toggleFullscreen() {
    if (isFullscreen()) {
        exitFullscreen();
    } else {
        enterFullscreen();
    }
}
